
import {loadIntroAnimations, loadRemainingAnimations, loadQ1Animations} from '../utils/animation';
const queryString = require(`query-string`);

// const queryStringToJSON = queryString => {
//     let newQuery = queryString;
//     if (newQuery.indexOf(`?`) > -1) {
//         newQuery = newQuery.split(`?`)[1];
//     }
//     let pairs  = newQuery.split(`&`);
//     let result = {};
//     let pair;
//     pairs.forEach(_pair => {
//         pair            = _pair.split(`=`);
//         result[pair[0]] = decodeURIComponent(pair[1] || ``);
//     });

//     return result;
// };

const parseQueryString = url => {
    const result = /\?.*/.exec(url);
    if (result) {
        return result[0];
    } else {
        return ``;
    }
};

const getQueryString =  () => queryString.parse(document.referrer === "" ? parseQueryString(window.location.search) : parseQueryString(document.referrer));

const stringifyQueryString = (queryObject, format) => queryString.stringify(queryObject, {arrayFormat: format});

const loadQueriedAnimations = () => {
    switch (getQueryString().q1) {
    case `family` :
        return Promise.all([loadQ1Animations(), loadRemainingAnimations(`family`)]).catch(console.error);
    case `retirement` :
        return Promise.all([loadQ1Animations(), loadRemainingAnimations(`retirement`)]).catch(console.error);
    case `empty_nester` :
        return Promise.all([loadQ1Animations(), loadRemainingAnimations(`empty_nester`)]).catch(console.error);
    case `disability` :
        return Promise.all([loadQ1Animations(), loadRemainingAnimations(`disability`)]).catch(console.error);
    default : {
        switch (getQueryString().m) {
            case `1` : 
                return Promise.all([loadQ1Animations(), loadRemainingAnimations(`family`)]).catch(console.error);
            case `2` :
                return Promise.all([loadQ1Animations(), loadRemainingAnimations(`retirement`)]).catch(console.error);
            case `3` :
                return Promise.all([loadQ1Animations(), loadRemainingAnimations(`empty_nester`)]).catch(console.error);
            case `4` :
                return Promise.all([loadQ1Animations(), loadRemainingAnimations(`disability`)]).catch(console.error);
            default :
                return Promise.all([loadIntroAnimations(), loadQ1Animations()]).catch(console.error);
            }
        }
    }
};

export {getQueryString, loadQueriedAnimations, stringifyQueryString};

